import { loadState } from 'utils/LocalStorage';

export const API_URL = {
	sampleUrl: '/sample/api',
	clubMemberApi: '/bp-club/club-member',
	clubV2Api: '/v2/bp-club/get-mdr-benefits',
	swipePaymentPlans: '/payment/plans/new',
	swipePaymentPlansV2: 'order/v2/payment/plans',
	swipeOldPaymentPlans: '/payment/plans',
	authenticate: '/authenticate',
	application: '/application',
	createApplication: '/application/new',
	createApplicationV2: 'order/v2/application/create',
	getAddress: '/v1/listaddress',
	togglePrintQr: '/account/toggle-print-qr/',
	fetchTxnList: 'https://payments-tesseract.bharatpe.in/api/v1/merchant/transactions',
	fetchTxnDetails: 'https://payments-tesseract.bharatpe.in/api/v1/merchant/transactions/',
	initiatePayment: '/payment/initiate/v1',
	initiatePaymentV2: 'order/v2/payment/initiate',
	checkPaymentStatus: '/payment/checkStatus',
	checkOGL: '/application/checkIfOGL',
	checkOGLV2: 'order/v2/application/checkIfOGL',
	checkIfAddressInVicinity: 'order/v2/application/validate-distance',
	openKycTaskWithNewAddress: 'application/update-rejected-address',
	kycStatus: '/application/kycDetails',
	kycStatusV2: '/order/v2/application/kycDetails',
	merchantInfo: '/v3/getmerchantinfo',
	initiateKYC: '/application/initiateKyc',
	initiateKYCV2: 'order/v2/application/initiateKyc',
	invoiceList: '/listing/getInvoice',
	settlementCsv: '/migration/settlement/csv',
	getWidgets: 'https://merchant-app-backend.bharatpe.in/api/v1/merchant/widgets',
	getFaqsMerchant: 'https://merchant-app-backend.bharatpe.in/api/v1/shared/faq',
	chargebackTxnsList: 'v1/app/chargeback/chargebackList',
	chargebackDetail: '/v1/app/chargeback/detail',
	chargebackUpload: '/v1/app/chargeback/document',
	chargebackRelease: '/v1/app/chargeback/release',
	chargebackGetImageUrl: '/v1/app/chargeback/documentUri',
	getMerchantDetailsList: '/application/merchantDeviceDetail',
	getActiveMachineCount: '/application/activeApplicationCount',
	getActiveMachineCountV2: 'order/v2/application/activeApplicationCount',
	getPendingApplication: '/application/pendingApplication',
	getPendingApplicationV2: 'order/v2/application/pendingApplication',
	getDeviceReturnList: '/application/swipeTerminal',
	getDeviceReturnStatusList: '/application/returnStatus',
	createReturnRequest: '/application/createReturn',
	cancelReturnRequest: '/application/cancelReturn',
	returnRefundDetails: '/application/refundDetail',
	fetchOverdueList: '/application/overdueAmount',
	fetchPlanChargesFromSerial: '/application/device/getPlanDetails',
	fetchDeterminePlanFlow: '/application/new/plan/validity',
	setTpvRanking: '/application/setRanking',
	getMdrCharges: '/application/merchant/mdrCharges',
	getCurrentMdrCharges: 'application/merchant/currentMdrCharges',
	getPincodeFromMerchantId: 'application/checkMerchantLocation',
	getRentalCashbackWaiver: 'order/v2/application/cashback/monthly',
	deliveryOrderDetails: '/application/order/status',
	getMigrationStatus: 'application/mdrMigrationStatus',
	merchantResponseMdrMigration: 'application/merchantResponseMdrMigration',
	createMachineOrderCancelRequest: 'application/cancelOrder',
	cancellationRefundStatus: 'application/cancelled/order',
	updateMerchantRanking: 'application/updateRankingType',
	retryTransaction: 'payment/retry',
	merchantMonthlyLimit: 'application/getMonthlyLimitDetails',
	getMerchantReturnedTerminals: 'listing/returnedTerminalsList',
	checkBlackListDocuments: 'application/isBlackListedDoc',
	getKycDocumentsList: 'https://api-kaas.bharatpe.in/api/v2/get-kyc?source=BHARATSWIPE&product=BHARATSWIPE',
	deactivateDevice: 'application/terminal/deactivate',
	deactivationStatus: 'application/terminal/deactivate/status',
	deactivationCancel: 'application/terminal/deactivate/cancel',
	saveTermsAndCondition: '/terms-conditions/tnc-acceptance',
	termsAndConditionsDetails: '/terms-conditions/get_tnc_details',
	updateMerchantProfileParameter: '/update-profile-parameter',
	getMerchantTerminals: '/listing/terminalList',
	claimPlanCoupon: 'coupon/claim',
	isAllowedToOrder: '/order/v2/application/allowed',
	getYearlyCashbackDetails: 'order/v2/application/cashback/yearly',
	getIsEligibleForPlanUpgrade: 'order/v2/payment/plan/upgrade/eligible',
	generateReferralLink: '/refer/referred/getReferralLink',
	checkMerchantReferral: '/refer/referred',
	getSpeakerActiveStatus: '/device-app-manager/soundbox/check-active-speaker',
	postSpekerAlertPreferenceToggle: '/account/toggle_transaction_alert',
	getSpeakerAlertPreference: '/account/fetch_transaction_alert_preference',
	disputeTxns: 'v1/app/chargeback/disputeAmount',
	qrDisputeTxns: 'v1/app/chargeback/disputeAmount',
	speakerReturnRequestConsent: '/order/v2/application/speaker-return-request-consent',
	soundbox: '/device-app-manager/soundbox/',
	kycDocRequestor: '/order/v2/application/kyc/requestor',
	swipeKycDocDetails: '/order/v2/application/kyc/swipe',
	paidStatusOrderTracking: '/order/v2/payment/tracking',
	getServiceRequestList: '/service/request',
	createServiceRequest: '/service/request',
	getServiceRequestDetails: '/service/request/details',
	getSwipeOrdersListing: '/order/v2/application/list-orders',
	getSwipeOrdersListingDetails: '/order/v2/application/order-details',
	getSwipeOrdersListingReturnDetails: '/order/v2/application/return-details',
	getSwipeCpvInfo: '/order/v2/application/get-cpv-info',
	invoiceThresholdCount: 'v1/app/chargeback/invoice',
	getLaunchLabsConfig: '/application/launch-lab/config',
	posDeviceDetails: '/application/existing-pos',
	ipTrackUrl: 'https://www.cloudflare.com/cdn-cgi/trace',
	applicationStatus: 'order/v2/application/status',
	chargebackRejectReasons: '/v1/app/chargeback/rejectionReason',
	checkMerchantDocumentValidation: 'v1/app/chargeback/feature-flag',
	validateUploadedDocument: 'v1/app/chargeback/ai/process/INVOICE_PARSER',
};
